import React, { useEffect } from "react";
import { toast } from "react-hot-toast";

import ModalContainer from "components/common/ModalContainer";
import Button from "components/common/Button";
import { salesActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";

type SalesOrderDeleteProps = {
    open: boolean;
    onClose: () => void;
    salesOrderIds: string[];
};

const SalesOrderDelete = (props: SalesOrderDeleteProps) => {
    const { open, onClose, salesOrderIds, ...rest } = props;

    const dispatch = useAppDispatch();

    const { deletingSalesOrder, deleteSalesOrderSuccess } = useAppSelector((state) => state.sales);

    const handleDeleteSalesOrder = () => {
        dispatch(salesActions.deleteSalesOrder(salesOrderIds));
    };

    useEffect(() => {
        if (deleteSalesOrderSuccess) {
            onClose();
            toast.success("Sales order deleted successfully");
            dispatch(salesActions.resetDeleteSalesOrderSuccess());
        }
    }, [deleteSalesOrderSuccess]);

    return (
        <ModalContainer
            open={open}
            showCloseIcon={false}
            modalClassName={""}
            tailwindClassName="w-[553px]"
            closeModal={onClose}
            {...rest}
        >
            <div className="bg-white p-6 shadow-cardShadow relative rounded-[8px]">
                <div>
                    <div>
                        <p className="text-lg font-rocGroteskMedium">Delete sales orders?</p>
                        <p className="text-base font-rocGroteskMedium text-slate-500 mt-1">
                            Are you sure you want to permanently delete the selected sales orders.
                            This action cannot be undone.
                        </p>
                    </div>

                    <div className="mt-6 flex justify-end gap-2">
                        <Button
                            btnText="Cancel"
                            type="button"
                            btnClassname="!py-3 !bg-n-20 !w-fit !text-dark-gray-2 !px-4"
                            onClick={onClose}
                            disabled={deletingSalesOrder}
                        />
                        <Button
                            btnText="Delete sales orders"
                            type="button"
                            btnClassname="!py-3 !w-fit !bg-[#E4281D] border border-r-50 !text-white !px-4"
                            onClick={handleDeleteSalesOrder}
                            isLoading={deletingSalesOrder}
                        />
                    </div>
                </div>
            </div>
        </ModalContainer>
    );
};

export default SalesOrderDelete;
